import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { Chart, ChartData, ChartOptions } from 'chart.js/auto';
import { DataSet } from '../domain/types/types';
import { ExternalTooltip } from '../domain/externalTooltip';
import { Day, Days, Hour } from '../domain/day';

@Component({
  selector: 'ps-ui-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.css'],
})
export class BarChartComponent implements OnInit, AfterViewInit {
  public chart: Chart;

  private readonly _borderWidth: 1;

  private _dataSets: Array<DataSet> = [];

  @Input()
  public elementId!: string;
  day: Days;

  @Input()
  set stacked(value: boolean) {
    this._options.scales.x = {
      stacked: value,
      grid: {
        display: false,
      },
      display: false,
    };
    this._options.scales.y = {
      stacked: value,
      grid: {
        display: false,
      },
      display: false,
    };
  }

  @Input()
  set dataSets(day: Day) {
    this.day = new Days([day]);
    const barDataSets = [
      {
        label: 'expected',
        data: day.hours.map((hour: Hour) => hour.expected),
        grouped: false,
        backgroundColor: 'rgba(206,212,218,0.5)',
        borderWidth: this._borderWidth,
      },
      {
        label: 'actual',
        data: day.hours.map((hour: Hour) => hour.actual),
        backgroundColor: 'rgba(99,166,210,255)',
        borderWidth: this._borderWidth,
      },
    ];
    this._dataSets = barDataSets;
  }

  @Output() getHour = new EventEmitter<Hour>();

  externalTooltip = (context: any) => {
    new ExternalTooltip().render(context, this.day, 'bar');
  };

  private _options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: false,
        grid: {
          display: false,
        },
        display: false,
      },
      y: {
        stacked: false,
        grid: {
          display: false,
        },
        display: false,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
        external: this.externalTooltip,
      },
    },
    layout: {
      padding: 0,
    },
    onClick: (e: any) => {
      const tooltipModel = e.chart.tooltip;
      const titleLines = tooltipModel.title || [];
      const day = this.day.getHour(titleLines);
      this.getHour.emit(day);
    },
  };

  public ngOnInit(): void {
    if (!this.elementId) {
      throw new Error('Element id must be provided');
    }
  }

  ngAfterViewInit(): void {
    this._build();
  }

  private _build() {
    const data = {
      labels: Array.from({ length: 24 }, (x, i) => i),
      datasets: this._dataSets,
    };
    this.chart = new Chart(this.elementId, {
      type: 'bar',
      data: <ChartData>data,
      options: <ChartOptions>this._options,
    });
  }
}
